// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag_wrapper__rjzLc","wrapperTiny":"Tag_wrapperTiny__by4ut","wrapperSmall":"Tag_wrapperSmall__rhXsh","wrapperMedium":"Tag_wrapperMedium__Rz88F"};